var App = {
    pages: {}
};

App.pages.contact = (function() {

    var init = function() {
        var maskBehavior = function(val) {
                return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
            },
            options = {
                onKeyPress: function(val, e, field, options) {
                    field.mask(maskBehavior.apply({}, arguments), options);
                }
            };

        $('input[name="phone"]').mask(maskBehavior, options);
        $('#contactForm').validate({
            rules: {
                name: {
                    required: true
                },
                email: {
                    email: true,
                    required: true
                },
                message: {
                    required: true
                }
            },
            messages: {
                name: {
                    required: Cookies.get('istlang') == 'pt' ? 'Informe seu nome.' : 'Enter your name.'
                },
                email: {
                    required: Cookies.get('istlang') == 'pt' ? 'Informe seu e-mail.' : 'Enter your email.',
                    email: 'Informe um endere\xE7o de e-mail v\xE1lido.'
                },
                message: {
                    required: Cookies.get('istlang') == 'pt' ? 'Informe sua mensagem.' : 'Enter your message.'
                }
            },
            highlight: function(element) {
                $(element).closest('.form-group').addClass('has-error');
            },
            unhighlight: function(element) {
                $(element).closest('.form-group').removeClass('has-error');
            },
            errorElement: 'span',
            errorClass: 'help-block',
            errorPlacement: function($error, element) {
                if (element.parent('.input-group').length) {
                    $error.insertAfter(element.parent());
                } else {
                    $error.insertAfter(element);
                }
            },
            submitHandler: function(form) {
                var $form = $(form),
                    data = {
                        name: $form.find('input[name="name"]').val(),
                        email: $form.find('input[name="email"]').val(),
                        phone: $form.find('input[name="phone"]').val(),
                        message: $form.find('textarea[name="message"]').val()
                    },
                    $btn = $('#btn-msg'),
                    clearForm = function(resetForm) {
                        $btn.prop('disabled', false);
                        $form.find('input, textarea').prop('disabled', false);
                        if (resetForm) {
                            $form.trigger('reset');
                        }
                    };
                $form.find('input, textarea').prop('disabled', true);
                $btn.prop('disabled', true);
                $.ajax({
                    url: '/contato',
                    type: 'POST',
                    data: data,
                    cache: false,
                    success: function() {
                        $('#success').html($('#success-msg').text());
                        clearForm(true);
                    },
                    error: function(res) {
                        $('#success').html($('#error-msg').text());
                        if (console.error) {
                            console.error(res);
                        }
                        clearForm();
                    }
                });
            }
        });

    };
    return {
        init: init
    };
})();

$(function() {
    var config = $('[data-page]').data();
    if (App.pages.hasOwnProperty(config.page)) {
        App.pages[config.page].init();
    }
});
